import { InjectionToken } from '@angular/core';

export const DIALOG_CLOSE = new InjectionToken<() => void>('DIALOG_CLOSE');
export const DISMISS_NOTIFICATIONS = new InjectionToken<(alertIds: number[], notificationIds: number[]) => void>('DISMISS_NOTIFICATIONS');
